export const PUBLIC_PAGES: string[] = [
  '/users/sign_in',
  '/users/sign_up',
  '/users/confirmation/new',
  '/users/password/new'
];

export function onPublicPage(): boolean {
  return PUBLIC_PAGES.includes(window.location.pathname.replace(/\/+$/, ''));
}
